import { render, staticRenderFns } from "./viewText.vue?vue&type=template&id=5836255a&scoped=true&"
import script from "./viewText.vue?vue&type=script&lang=js&"
export * from "./viewText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836255a",
  null
  
)

export default component.exports